import {FC} from 'react'
import {Redirect, useParams} from 'react-router-dom'
import {useQuery} from 'hooks/graphql'
import {LoadingPage} from 'components/ui/LoadingPage'
import {CONTRACTS, ContractsQueryResult, ContractsQueryVariables} from './query'
import {Presenter} from './Presenter'

export const Show: FC = () => {
  const {id} = useParams<{id: string}>()

  const {data, loading} = useQuery<ContractsQueryResult, ContractsQueryVariables>(CONTRACTS, {
    fetchPolicy: 'network-only',
    variables: {
      employeeId: id,
      statuses: ['success'],
    },
  })

  if (loading) {
    return <LoadingPage />
  }

  const client = data?.client
  const employee = client?.employee
  if (!client || !employee) return null

  const isAllowedSendContract = client.planType === 'paid_plan' && client.isVerified
  if (!isAllowedSendContract || employee.employeeDocumentContractRequests.length === 0) {
    return <Redirect to={`/documents/employees/${id}`} />
  }

  return <Presenter employee={employee} contracts={employee.employeeDocumentContractRequests} />
}
